/**
 * SubNavigationComponent contains two types of buttons container components.
 *
 * The ButtonListComponent wich shows rectangular buttons.
 *
 * The RoundPickerButtonComponent wich shows round buttons.
 *
 * This component controls the display of one or the other.
 *
 * @Author: Jon Lucas
 * @Date:   2017-09-22T17:17:07+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-29T18:04:47+02:00
 */

import { Component, Input } from "@angular/core";

import { Router, NavigationEnd, UrlTree } from "@angular/router";

import { Location } from "@angular/common";

import { AbstractComponent } from "../../abstract-component/abstract.component";
import { AppService } from "../../app.service";

import { BaseDataType } from "../../base-data-type";

import { ServiceLocator } from "../../service-locator";

@Component({
    selector: "app-sub-navigation",
    templateUrl: "./sub-navigation.component.html",
    styleUrls: ["./sub-navigation.component.scss"]
})
export class SubNavigationComponent extends AbstractComponent {

    public readonly TAG: string = "[SubNavigationComponent]";

    protected router: Router;

    private readonly BUTTON_PICKER_COMPONENT: string = "button-picker-component";
    private readonly BUTTON_LIST_COMPONENT: string = "button-list-component";

    public types: BaseDataType[];

    @Input() public lang: string;

    @Input() public selectedType: BaseDataType;

    private subcomponentType: string;

    private _typeId: string;
    private _subtypeId: string;

    @Input() optionsLabel: string;
    private _options: BaseDataType[];

    public showValidationButton: boolean;


    constructor(private location: Location) {
        super();

        this.router = ServiceLocator.injector.get(Router);
    }

    public get typeId(): string {
        return this._typeId;
    }

    @Input() public set typeId(pId: string) {
        this._typeId = pId;

        console.log(this.TAG, "typeId()", pId);

        if (this.types && (this.selectedType === undefined || this.selectedType.id !== this.typeId)) {
            this.selectedType = this.types.find(type => type.id === this.typeId);
            console.log(this.TAG, "set typeId", this.selectedType, this.lang);
        }
    }

    public get subtypeId(): string {
        return this._subtypeId;
    }

    @Input() public set subtypeId(pId: string) {
        this._subtypeId = pId;

        console.log(this.TAG, "subtypeId()", pId);

        this._checkSelectionState(this._subtypeId);

        if (!this._subtypeId || this.options) {
            return;
        }

        switch (this._subtypeId) {
            // case "roof-type-options" :
            //     this.subcomponentType = this.BUTTON_PICKER_COMPONENT;
            //     break;

            default:
                this.subcomponentType = this.BUTTON_LIST_COMPONENT;
                break;
        }
    }

    public get options(): BaseDataType[] {
        return this._options;
    }

    @Input() public set options(pOptions: BaseDataType[]) {
        this._options = pOptions;

        console.log(this.TAG, "options()", this._options);

        this._checkSelectionState(this._subtypeId);

        if (!this._options) {
            return;
        }

        for (const option of this._options) {
            if (!option) { continue; }

            switch (option.id) {
                // case "one-pan-surelevation":
                //     this.subcomponentType = this.BUTTON_PICKER_COMPONENT;
                //     break;

                default:
                    // If option id contains 'colors' or 'surelevation' string, we show color picker component
                    this.subcomponentType = option.id.indexOf("colors") !== -1 || option.id.indexOf("surelevation") !== -1 ? this.BUTTON_PICKER_COMPONENT : this.BUTTON_LIST_COMPONENT;
                    break;
            }
        }
    }

    public getData(): void {
        super.getData();

        this.types = undefined;

        this.appService.getData(AppService.NAVIGATION_MENU_URL).then(
            types => {
                this.types = types;
                // Force values to update selectedType
                this.typeId = this.typeId;
            }
        );
    }

    private _checkSelectionState(pUpdatedValueId): void {
        if (pUpdatedValueId === this.subtypeId) {
            this.showValidationButton = false;
            if (this.options && this.confDataService.getElementOptions(this.subtypeId)) {
                this.showValidationButton = this.confDataService.getElementOptions(this.subtypeId).length === this.options.length;
            }
            else if (this.confDataService.getElementValues(this.subtypeId)) {
                this.showValidationButton = this.confDataService.getElementValues(this.subtypeId).length === 1;
            }
        }

        console.log(this.TAG, "showValidationButton", this.showValidationButton);
    }

    public ngOnInit(): void {
        super.ngOnInit();

        // Listen to confguration update events
        this.confDataService.observable.subscribe(
            value => this._checkSelectionState(value.id)
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/main-left-column/sub-navigation/sub-navigation.component.ts